import {
  IRoutingProjectDatasetLocation,
  IRoutingProjectPlanOptimization,
  IRoutingProjectPlanOptimizationRoute
} from 'features/RoutingProjects/types'

export const updateRoutesByTouchedRoutes = (
  routes: IRoutingProjectPlanOptimizationRoute[],
  touchedRoutes: IRoutingProjectPlanOptimizationRoute[],
  selectedOptimization: IRoutingProjectPlanOptimization | undefined
): { updatedRoutes: IRoutingProjectPlanOptimizationRoute[]; updatedRoutesIndex: number[] } => {
  const updatedRoutesIndex: number[] = []

  const updatedRoutes = routes.map((route, routeIndex) => {
    const touchedRoute = touchedRoutes.find((r) => r.groupId === route.groupId)
    if (touchedRoute) {
      const updatedRoute = selectedOptimization?.routes.find((r) => r.id === touchedRoute?.id)
      updatedRoutesIndex.push(routeIndex)
      if (updatedRoute) {
        return {
          ...route,
          groupId: updatedRoute.groupId,
          stops: [...updatedRoute.stops]
        }
      }
    }
    return route
  })

  return { updatedRoutes, updatedRoutesIndex }
}

export const getUpdatedSkippedLocations = (
  optimization: IRoutingProjectPlanOptimization,
  updatedLocation: IRoutingProjectDatasetLocation | null,
  selectedOptimization: IRoutingProjectPlanOptimization | undefined
): IRoutingProjectPlanOptimization['skippedLocations'] => {
  const updatedLocationIsSkippedInsideSelectedOptimization = selectedOptimization?.skippedLocations.some(
    (skippedLocation) => skippedLocation.location.id === updatedLocation?.id
  )
  let newSkippedLocations = [...optimization.skippedLocations]
  const updatedLocationIsSkipped = optimization.skippedLocations.some(
    (skippedLocation) => skippedLocation.location.id === updatedLocation?.id
  )

  if (updatedLocationIsSkipped) {
    if (!updatedLocationIsSkippedInsideSelectedOptimization) {
      newSkippedLocations = newSkippedLocations.filter(
        (skippedLocation) => skippedLocation.location.id !== updatedLocation?.id
      )
    }
  } else {
    if (updatedLocationIsSkippedInsideSelectedOptimization) {
      const skippedLocation = selectedOptimization?.skippedLocations.find(
        (skippedLocation) => skippedLocation.location.id === updatedLocation?.id
      )
      if (skippedLocation) {
        newSkippedLocations = [...newSkippedLocations, skippedLocation]
      }
    }
  }

  return newSkippedLocations
}
